'use strict';

var autenticacaoMdl = angular.module('autenticacaoMdl', []);

autenticacaoMdl

/**
 * Configurações de rota
 */
 .config(['$stateProvider', function ($stateProvider) {

     $stateProvider

     .state('autenticacao', {
         abstract: true,
         template: '<ui-view></ui-view>'
     })

     .state('autenticacao.login', {
         url: "/login",
         controller: 'autenticacaoCtrl',
         template: require('./login.html')
     });


 }])

/**
 * Configurações de interceptadores
 */
.config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('AutenticacaoItp');
}])



// WEBPACK FOOTER //
// ./src/modules/autenticacao/autenticacao-config.js